import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Button
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

export default function Topbar() {
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    window.location.href = '/login';
  };

  const role = localStorage.getItem('role') || 'Admin';

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: 'linear-gradient(90deg, #0f2027, #203a43)',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      <Toolbar
        sx={{
          minHeight: 64,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {/* Left: Page Title / Brand */}
        <Typography variant="h6" fontWeight="bold">
          Admin Dashboard
        </Typography>

        {/* Right: User Info + Logout */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="body2" fontWeight="bold">
              {role}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              Logged in
            </Typography>
          </Box>

          <Avatar
            sx={{
              bgcolor: '#42a5f5',
              width: 36,
              height: 36,
              fontSize: 14,
            }}
          >
            {role.charAt(0)}
          </Avatar>

          <Button
            variant="outlined"
            color="inherit"
            startIcon={<LogoutIcon />}
            onClick={logout}
            sx={{
              borderColor: 'rgba(255,255,255,0.4)',
              '&:hover': {
                borderColor: '#fff',
                background: 'rgba(255,255,255,0.08)',
              },
            }}
          >
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
